"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroUnconnectedPinNamingRule = void 0;
exports.unconnectedPinNetName = unconnectedPinNetName;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class AllegroUnconnectedPinNamingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, _hierarchy) {
        let allPlaceholder = false;
        for (const [, nets] of group.getNets()) {
            for (const net of nets) {
                const name = net.name.valueOf();
                if (!name.startsWith('__UNNAMED_NET_')) {
                    return undefined;
                }
                allPlaceholder = true;
            }
        }
        if (!allPlaceholder) {
            return undefined;
        }
        const connections = group.getConnections();
        if (connections.length === 0) {
            return undefined;
        }
        const firstConnection = connections[0];
        return `unconnected-(${firstConnection.moduleName}-${firstConnection.pinRef})`;
    }
}
exports.AllegroUnconnectedPinNamingRule = AllegroUnconnectedPinNamingRule;
function unconnectedPinNetName(moduleName, pinRef) {
    return `unconnected-(${moduleName}-${pinRef})`;
}
//# sourceMappingURL=AllegroUnconnectedPinNamingRule.js.map